import $ from "jquery";


const _window           = $(window);
const _body             = $('body');
const _positionTrigger  = 0;
let   _positionCurrent	= 0;
let   _positionLast	    = 0;


const initAppScroll = function(){

    _positionCurrent 			= _window.scrollTop();


    if (!_body.hasClass("no-sticky")) {

        if(_positionCurrent > _positionTrigger) {
            _body.addClass("header--sticky");
            if (_positionLast>_positionCurrent) {
                _body.addClass("header--sticky-up");
            } else {
                _body.removeClass("header--sticky-up");
            }
        } else {
            _body.removeClass("header--sticky");
            _body.removeClass("header--sticky-up");
        }
    
        if (_positionLast<_positionCurrent && _positionLast > 200) {
            _body.addClass("footer--sticky");
        } else {
            _body.removeClass("footer--sticky");
        }
    
    }

    _positionLast = _positionCurrent;

};


export const initHeader = function() {
  
    _window.on('scroll', initAppScroll);

};